<template>
  <div class="form-control">
    <template v-if="!isEdit">
      <slot></slot>
      <a
        href="javascript:void(0);"
        @click="isEdit = true"
        v-if="$store.getters.getPackage == 'premium'"
      >
        <span class="fas fa-pencil-alt"></span>
      </a>
    </template>
    <template v-else>

      <multiselect 
      id="ajax"
        v-model="customer_value" 
        :options="allSchools"
        :internal-search="true"
        :options-limit="10"
        :loading="isLoading"
        :show-no-results="true" 
        @search-change="asyncFindSchools"
        :placeholder="$t('School')" 
        label="name" 
        track-by="name">
      </multiselect>

      <div class="text-xs-center">
        <v-btn outline color="grey" small @click="cancelEdit">{{$t('cancel')}}</v-btn>
        <v-btn depressed color="primary" small @click="saveEdit">{{$t('Save')}}</v-btn>
      </div>
    </template>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'

export default {
  props: {
    value: {
      default: undefined
    },
    userid: {
      default: undefined
    },
    placeholder: {
      default: ''
    }
  },
  data: function() {
    return {
      allSchools: [],
      isLoading: false,
      isEdit: false,
      customer_value: ''
    }
  },
  mounted: function() {
    this.customer_value = this.value
    this.cached_customer_value = this.value
  },
  components: {
    Multiselect
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
    })
  },
  methods: {
    simulateKeyPress(character) {
      jQuery.event.trigger({ type : 'keypress', which : character.charCodeAt(0) });
    },
    asyncFindSchools(data) {
      let vm = this
      if(!vm.allSchools.length && !vm.isLoading) {
        vm.isLoading = true
        api.getschoollist(data, function(error, response) {
          if (error) {
            console.error(error)
          }
          else {
            vm.allSchools = response.data
            vm.isLoading = false
          }
        })
      }
    },
    cancelEdit: function() {
      this.isEdit = false
      this.customer_value = this.cached_customer_value
    },
    saveEdit: function() {
      var vm = this
      var data = {
        pageid: vm.selectedBot.pageid,
        usersid: vm.userid,
        customer_value: vm.customer_value.name,
        onEdit: function() {
          vm.isEdit = false
          vm.cached_customer_value = vm.customer_value
          vm.$emit('input', vm.customer_value.name)
        }
      }
      vm.$emit('onEdit', data)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/dashboard/EditCustomerSchool.vue